import { Component, uiElement, uiEvent } from "@kluntje/core";
import { addClass, removeClass, waitFor } from "@kluntje/js-utils/lib/dom-helpers";
import { OPEN } from "Constants/cssClasses";
import FocusService from "Services/FocusService";
import ScrollLockService from "Services/ScrollLockService";

export class WECNavigation extends Component {
  @uiElement(".wec-m-navigation__closing-btn")
  closeBtn: HTMLButtonElement;

  @uiElement(".wec-m-navigation__flyout")
  flyout: HTMLDivElement;

  open() {
    addClass(this, OPEN);
    FocusService.trapFocusIn(this);
    ScrollLockService.lockPage();
  }

  @uiEvent("flyout", "click")
  handleFlyoutClick(e: MouseEvent) {
    e.stopPropagation();
  }

  @uiEvent("this", "click")
  handleOutsideClick() {
    this.close();
  }

  @uiEvent("closeBtn", "click")
  async close() {
    removeClass(this, OPEN);
    await waitFor(300);
    FocusService.unTrapFocusIn(this);
    ScrollLockService.unlockPage();
  }
}

customElements.define("wec-m-navigation", WECNavigation);
